export default __webpack_public_path__ + "static/media/upload.d46193df.svg";